var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-layout"},[_vm._m(0),_c('div',{staticClass:"content"},[_c('router-view',{attrs:{"data-slot":"targetContent"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{staticStyle:{"width":"82px","height":"24px"},attrs:{"src":require("@/images/logo-dark.svg")}})])
}]

export { render, staticRenderFns }